/**
 * Shared character limits for USER-TYPED text fields.
 *
 * These caps apply to what a person types into a form — never to AI/Coach
 * output or any app-generated text. Both the UI (input `maxLength` +
 * counters) and the server validators import from here so the two can't
 * drift apart.
 */
export const INPUT_LIMITS = {
  /** @handle used for sign-in and mentions. */
  username: 30,
  /** Display name shown in the header/greeting. */
  displayName: 30,
  /** Group name (create + rename). */
  groupName: 25,
  /** Challenge / shared-plan name. */
  challengeName: 25,
  /** A single user message typed into the Coach chat box. */
  coachMessage: 100000,
  /** "Additional details" on the report-a-user form. */
  reportNote: 1000,
  /** Manual plan editor: custom exercise name. */
  manualExerciseName: 60,
  /** Manual plan editor: exercise note. */
  manualExerciseNote: 250,
  /** Manual plan editor: meal name. */
  manualMealName: 50,
  /** Pair hand-off shared-plan title. */
  pairPlanTitle: 25,
  /** Train Together / joint session title. */
  jointSessionTitle: 25,
  /** Free-text onboarding answers (per field). */
  onboardingText: 1000,
} as const;

export const USERNAME_MIN = 3;
